import 'normalize.css';

import store from '@Store/store';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { enableMapSet } from 'immer';

// Dayjs set default timezone
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// MSAL imports
import {
  AccountInfo,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser';

import { msalConfig } from './config/authConfig';

import getRouter from './router/router';
import reportWebVitals from './reportWebVitals';

// Enable MapSet plugin
enableMapSet();

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault('UTC');

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  if (
    !msalInstance.getActiveAccount() &&
    msalInstance.getAllAccounts().length > 0
  ) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event?.payload) {
      const { account } = event.payload as { account: AccountInfo };
      msalInstance.setActiveAccount(account);
    }
  });
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <RouterProvider router={getRouter()} />
      </Provider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
